import { Button, TextField, InputAdornment, styled, Box } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { useEffect, useState } from 'react'
import { SPACING } from '@common/theme/spacing'
import { SIZING } from '@common/theme/sizing'
import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import { QueryPermission } from '@auth/permissionsEnum'

export interface QueriesTableToolbarProps {
  onSearch: (value: string) => void
  searchValue?: string
  onCreateClick: () => void
}

const ToolbarContainer = styled(Box)({
  padding: 16,
  display: 'flex',
  gap: 24,
  alignItems: 'center',
})

export default function QueriesTableToolbar({
  onSearch,
  searchValue,
  onCreateClick,
}: Readonly<QueriesTableToolbarProps>) {
  const [localSearchValue, setLocalSearchValue] = useState(searchValue ?? '')

  const { hasPermission } = useCombinedPermissions()

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchValue(event.target.value)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      onSearch(localSearchValue)
    }
  }

  useEffect(() => {
    setLocalSearchValue(searchValue ?? '')
  }, [searchValue])

  return (
    <ToolbarContainer
      sx={{
        paddingX: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        gap: SPACING.tableToolbarItemsSpacing,
      }}
    >
      {hasPermission(QueryPermission.CREATE) && (
        <Button variant="contained" color="secondary" startIcon={<AddIcon />} size="small" onClick={onCreateClick}>
          Create query
        </Button>
      )}
      <TextField
        placeholder="Search"
        variant="outlined"
        size="small"
        sx={{ minWidth: SIZING.textFieldWidth }}
        value={localSearchValue}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
    </ToolbarContainer>
  )
}
